module.exports = __webpack_public_path__ + "img/a6b559f7ebb9e9e084e1834b09e10ea2.png";